import { styled } from 'styled-components'

export const StyledHeader = styled.header(({ theme }) => `
  grid-area: header;
  position: sticky;
  top: 0;
  z-index: 20;
  backdrop-filter: blur(12px);
  background: ${theme.colors.surface.glass};
  border-bottom: 1px solid ${theme.colors.border.soft};
  box-shadow: 0 18px 34px ${theme.colors.shadow.soft};
  font-size: 28px;
`)

export const StyledMain = styled.main`
  grid-area: content;
  width: min(1080px, 92vw);
  display: flex;
  flex-direction: column;
  place-self: center center;
  padding-bottom: 5rem;
`

export const StyledSection = styled.section`
  margin: 1.4rem 0;
  padding: 1.6rem 2rem 2rem;
  border-radius: 28px;
  border: 1px solid ${({ theme }) => theme.colors.border.soft};
  background: ${({ theme }) => theme.colors.surface.glass};
  box-shadow: 0 20px 40px ${({ theme }) => theme.colors.shadow.soft};

  @media (max-width: ${({ theme }) => theme.screen.small}) {
    margin: 0.9rem 0;
    padding: 1.1rem 0.9rem 1.3rem;
    border-radius: 20px;
  }
`

export const StyledSectionName = styled.h2`
  position: relative;
  width: fit-content;
  margin: 0 auto;
  padding: 0 1rem 0.4rem;
  font-size: clamp(2rem, 4vw, 2.6rem);
  font-family: ${({ theme }) => theme.fonts.title.lineTwo};
  letter-spacing: 0.08em;
  /* text-transform: uppercase; */
  text-align: center;

  &::after {
    content: '';
    position: absolute;
    left: 20%;
    right: 20%;
    bottom: 0;
    height: 4px;
    border-radius: 10px;
    background: ${({ theme }) => theme.colors.gradient.spotlight};
  }

  @media (max-width: ${({ theme }) => theme.screen.small}) {
    letter-spacing: 0.04em;
  }
`

// in layout not about in case text is added elsewhere
export const StyledSectionText = styled.p<{
  $textAlign?:'left'|'center',
}>`
  font-size: clamp(1.15rem, 2.5vw, 1.5rem);
  font-weight: normal;
  line-height: 1.8;
  text-align: ${({ $textAlign }) => $textAlign || 'left'};
  color: ${({ theme }) => theme.colors.palette.secondary};
  margin: 1.2rem 0 0;

  @media (max-width: ${({ theme }) => theme.screen.small}) {
    margin: 0.9rem 0.2rem 0;
  }
`
